<template>
    <v-app>
      <v-container fluid>
        <v-row class="text-center">
          <v-col cols="12">
            <h1>Data Health Grid</h1>
            <router-link to="/new" class="new-page-button">Single Point Long History Data Health</router-link>
          </v-col>
        </v-row>
        <v-row justify='space-between'>
          <div class="col-md-2">
            <h2>Pick end date below</h2>
            <v-text-field v-model="dateRangeText" readonly></v-text-field>
            <v-date-picker dark scrollable v-model="date" :max="maxDate" full-width no-title></v-date-picker>
            <br />
            <!-- Date Picked: <b>{{ this.date }}</b> -->
            <div class="row">
              <div class="col-md-12">
                <v-btn block @click="getData(date)" >{{ this.currentText }}</v-btn>
              </div>
            </div>
            <!-- <div><v-btn @click="getData(date)" >Get Data</v-btn></div>
            <div><v-btn @click="sort()">Sort the Data</v-btn></div> -->
          </div>
          <div class="col-md-9">
            <p> This app visualizes the mathematical difference between real data and its algorithmically ingested counterparts. Please select a date and click the Go button.</p>
            <p> This is a time-expensive calculation so the time range is limited to 1 week and the processing will take up to 1 minute.</p>
            <p> After the graph has been plotted, sort the results by clicking the Sort Graph button below.</p>
            <p> Hover your mouse over any particular tile to see its information.</p>
            <p> Ascending order runs Bottom to Top (within a column) and Left to Right (across columns). </p>
            <p> A health score of 100 means no difference between real meter data and ingested data. <span style="color:green;">Green</span></p>
            <p> A health score of 0 means complete disagreement between the real meter data and ingested data. <span style="color:red;">Red</span> </p>
            <v-card-actions>
              <v-btn v-if="data && !sorted" @click="sort()" style="margin-left: 400px;">Sort Graph</v-btn>
              <v-btn v-if="data && sorted" @click="sort()" style="margin-left: 390px;">Unsort Graph</v-btn>
            </v-card-actions>
            
          </div>
          <ChartArea :data="data" :xLabels="xLabels" :yLabels="yLabels" /> <!--make sure to pass the graph options here-->
        </v-row>
        <div v-if="!data" style="text-align: center">
          <v-img src="../assets/blankHeatmap.png" class="mx-auto" width="81%" style="margin-top: 10px;"></v-img>
        </div>
      </v-container>
    </v-app>
  </template>
  
  <script>
  import axios from 'axios'
  import ChartArea from '@/components/ChartArea.vue';
  import "../assets/styles.css";
  
  export default {
    name: 'App',
  
    data() {
      return{
        date: '',
        data: null,
        rowSize: null,
        xLabels: '',
        yLabels: '',
        tempData: null,
        maxDate: new Date(Date.now()- (1000 * 60 * 60 * 24 * 1)).toISOString(), // makes sure that ineligible dates cannot be selected
        sorted: false,
        unsortedData: '',
        currentText: "Go!",
      }
    },
  
    computed: {
      dateRangeText () {
        if(!this.date){
          return "Please select a date!"
        } else {
          let startDate = new Date(this.date)
          startDate.setDate(startDate.getDate() - 6)
          var output = startDate.getFullYear() + '-' + (startDate.getMonth() + 1 < 10 ? '0' : '') + (startDate.getMonth() + 1) + '-' + ((startDate.getDate()) < 10 ? '0' : '') + (startDate.getDate());
          return [output, this.date].join(" ~ ")
        }
      },
    },
  
    methods: {
      sort() {
        if(!this.sorted){
          let arr = this.data
          this.unsortedData = JSON.parse(JSON.stringify(this.data)); // making a copy of the data without reference
          arr.sort((a,b) => a.value[2] - b.value[2]);
  
          for(let i=0;i<Object.keys(this.tempData.name).length;i++){
            let rowCount = parseInt(i/this.rowSize);
            let colCount = parseInt(i%this.rowSize);
            arr[i].value[0] = rowCount
            arr[i].value[1] = colCount
          }
  
          this.data = arr
        } else {
          this.data = JSON.parse(JSON.stringify(this.unsortedData));
        }
        this.sorted = !this.sorted
      },
      getData(date) {
        this.currentText = 'Loading...'
        this.sorted = false // ensures that the unsort button does not show when new data is generated
        if(this.data){
          this.data = null // makes sure that graph resets when a new date is selected
        }
        console.log('Trying to get data')
        let end = date;
        let start = new Date(end); 
        start.setDate(start.getDate() - 7); // computes 7 days before the selected date
        // let dateRange = `${start.toISOString().slice(0, 10)}..${end}`; // outputs the date range in the accepted api format
  
        let apiRequest = {
            // "mthd": "getData",
            "how": "wide",
            "startDate" : start.toISOString().slice(0, 10), 
            "endDate" : end,
            // "date": dateRange,
            "rollup": "avg",
            "intv": "1hour",
            "table": 0,
            // "slice": "200"
        }
  
        axios.post('https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizMain', // changed to real API url. TEST: http://127.0.0.1:5000/ingestVizMain. REAL: https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizMain
        apiRequest
        )
        .then((response) => {
          console.log('Got the data!')
            this.tempData = response.data
            // console.log(tempData)
            this.rowSize = Math.ceil(Math.sqrt(Object.keys(this.tempData.name).length))
  
            let formattedTemp = [];
  
            for(let i=0;i<Object.keys(this.tempData.name).length;i++){
              let name = this.tempData.name[i];
              let value = 100 - this.tempData.percentDiff[i];
              let rowCount = parseInt(i/this.rowSize);
              let colCount = parseInt(i%this.rowSize);
              formattedTemp.push({name: name.slice(0,4)+'\n'+name.slice(4), value: [rowCount, colCount, parseFloat((value).toFixed(2))], label: {show: true}});
            }
  
            this.data = formattedTemp;
            // console.log(this.data)
  
            this.xLabels = [...Array(this.rowSize).keys()];
            this.yLabels = [...Array(this.rowSize).keys()];
            
            // console.log(this.data)
            this.currentText = "Go!"
            return this.data
        })
      },
    },
    components: {
      ChartArea,
    }
  };
  </script>
  